import { SEO_ACTION } from "./actionTypes";
export const SeoStateSelectors = {
  getMeta: state => state.seo[SEO_ACTION.GET_META],
  list: state => state.seo[SEO_ACTION.LIST_META],
  view: state => state.seo[SEO_ACTION.VIEW_META],
  create: state => state.seo[SEO_ACTION.CREATE_META],
  update: state => state.seo[SEO_ACTION.UPDATE_META],
  delete: state => state.seo[SEO_ACTION.DELETE_META]
};